/* Bedtextielonline (Claude): slimme zoekfunctie die mensentaal begrijpt en vooral naar de juiste categorie leidt.
   - Alle collecties komen uit /collections?view=btol-zoekindex (templates/list-collections.btol-zoekindex.liquid), 6 uur bewaard per bezoek.
   - Woorden worden gelijkgetrokken: meervoud (hoeslakens = hoeslaken), bijvoeglijk (flanellen = flanel), synoniemen (dekbedhoes = dekbedovertrek,
     handdoeken = badtextiel, warm = flanel/winter, tweepersoons = 200/240), samenstellingen (winterdekbed = winter + dekbed) en kleine tikfouten.
   - In het zoekvenster vult dit het blok 'Categorieën' (ook als de gewone zoekfunctie niets vindt).
   - Enter in het zoekvenster met één duidelijke categorie (bv. 'flanellen dekbedovertrekken') gaat meteen naar die categorie;
     de knop 'Alle resultaten' gaat altijd naar de zoekpagina.
   - De zoekpagina (sections/btol-zoek-kop.liquid) gebruikt dezelfde motor via window.btolZoekSlim.
   Nieuwe synoniemen: aanvullen in SYN hieronder. */
(function () {
  if (window.btolZoekSlim) return;
  var btolT = function (k, d, v, ruw) { var s = (window.BTOL_T && window.BTOL_T[k]) || d; if (!ruw && !/_html$/.test(k)) s = String(s).replace(/&(#39|#x27|quot|lt|gt|amp);/g, function (m, e) { return { '#39': "'", '#x27': "'", quot: '"', lt: '<', gt: '>', amp: '&' }[e]; }); if (v) Object.keys(v).forEach(function (n) { s = String(s).split('{' + n + '}').join(v[n]); }); return s; };
  /* ---------- taal: woorden gelijk trekken (meervoud, synoniemen, samenstellingen) ---------- */
  var STOP = ' de het een en of voor met van in op aan mijn ons onze ik we wij zoek zoeken zoekt naar welke wat graag is zijn te kopen bestellen goedkoop goedkope mooi mooie leuk leuke bed bedden cm x & - nodig heb wil ';
  var SYN = {
    flanellen: 'flanel', flanelle: 'flanel', flannel: 'flanel', flanelen: 'flanel',
    katoenen: 'katoen', cotton: 'katoen', percale: 'percal', perkal: 'percal',
    satijnen: 'satijn', satin: 'satijn', satinet: 'satijn',
    dekbedhoes: 'dekbedovertrek', dekbedhoezen: 'dekbedovertrek', dekbedovertrekken: 'dekbedovertrek', dekbedovertrekje: 'dekbedovertrek',
    overtrek: 'dekbedovertrek', overtrekken: 'dekbedovertrek', duvet: 'dekbedovertrek', donsovertrek: 'dekbedovertrek',
    hoeslakens: 'hoeslaken', hoeslakentje: 'hoeslaken', hoeslaaken: 'hoeslaken',
    lakens: 'laken', bovenlakens: 'bovenlaken laken', bovenlaken: 'bovenlaken laken',
    lakensets: 'lakenset laken', lakenset: 'lakenset laken',
    kussenslopen: 'kussensloop', sloop: 'kussensloop', slopen: 'kussensloop', kussenhoes: 'kussensloop', kussenhoezen: 'kussensloop', kussensloopen: 'kussensloop',
    dekbedden: 'dekbed', deken: 'dekbed', dekens: 'dekbed', donsdeken: 'dons dekbed', donsdekens: 'dons dekbed', donzen: 'dons', donsdekbed: 'dons dekbed',
    winterdekbed: 'winter dekbed', winterdekbedden: 'winter dekbed', zomerdekbed: 'zomer dekbed', zomerdekbedden: 'zomer dekbed',
    herfstdekbedden: 'herfst dekbed', herfstdekbed: 'herfst dekbed', lentedekbed: 'lente dekbed',
    hoofdkussens: 'kussen', hoofdkussen: 'kussen', kussens: 'kussen', sierkussens: 'sierkussen kussen', sierkussen: 'sierkussen kussen',
    kids: 'kids', kind: 'kids', kinder: 'kids', kinderen: 'kids', baby: 'kids', babys: 'kids', jongens: 'kids', meisjes: 'kids', kinderkamer: 'kids', tiener: 'kids',
    matrasbeschermers: 'matrasbeschermer', matrasbeschemers: 'matrasbeschermer', matrasbeschermertje: 'matrasbeschermer', beschermer: 'matrasbeschermer',
    waterdichte: 'waterdicht', toppers: 'topper', boxsprings: 'boxspring', boxspringbed: 'boxspring',
    badlaken: 'badtextiel', badlakens: 'badtextiel', handdoek: 'badtextiel', handdoeken: 'badtextiel', washand: 'badtextiel', washanden: 'badtextiel', strandlaken: 'badtextiel strandlaken',
    badjassen: 'badjas', badmatten: 'badmat', plaids: 'plaid', fleece: 'plaid',
    sprei: 'bedsprei', spreien: 'bedsprei', bedspreien: 'bedsprei',
    kerstmis: 'kerst', christmas: 'kerst', uni: 'effen', egaal: 'effen',
    eenpersoons: '140', eenpersoonsbed: '140', '1persoons': '140', tweepersoons: '200 240', tweepersoonsbed: '200 240', '2persoons': '200 240',
    litsjumeaux: '240', jumeaux: '240', koel: 'zomer', verkoelend: 'zomer', zomers: 'zomer',
    warm: 'flanel|winter', warme: 'flanel|winter', winters: 'winter', seizoenen: 'seizoen',
    stretch: 'jersey', rekbaar: 'jersey', hoog: 'hoge', hoge: 'hoge', extra: 'hoge', diepe: 'hoge', aanbieding: 'uitverkoop', solden: 'uitverkoop', sale: 'uitverkoop', korting: 'uitverkoop',
    nieuw: 'nieuwe', tencel: 'lyocell', mousseline: 'tetra', hydrofiel: 'tetra',
    /* lazy dekbed = dekbed en overtrek in één */
    lazy: 'lazy', lui: 'lazy', luie: 'lazy', allinone: 'lazy', overtrekloos: 'lazy', zonder: 'zonder',
    /* vaste woorden die niet in stukken mogen */
    hoeslaken: 'hoeslaken', kussensloop: 'kussensloop', dekbedovertrek: 'dekbedovertrek', strandlakens: 'badtextiel strandlaken',
    hoes: 'dekbedovertrek|hoeslaken|kussensloop', hoezen: 'dekbedovertrek|hoeslaken|kussensloop', beddengoed: 'beddengoed'
  };
  var KOPPEN = ['dekbedovertrek', 'dekbedden', 'dekbed', 'hoeslakens', 'hoeslaken', 'lakens', 'laken', 'kussens', 'kussen', 'slopen', 'sloop'];

  function plat(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/(\d)\s*-?\s*persoons/g, '$1persoons').replace(/lits?\s*-?\s*jumeaux/g, 'litsjumeaux').replace(/all\s*-?\s*in\s*-?\s*(one|1|een)\b/g, 'allinone')
      .replace(/(\d+)\s*[x×]\s*(\d+)/g, '$1x$2').replace(/[^a-z0-9x]+/g, ' ').trim();
  }
  /* één woord -> lijst van 'begrippen'; elk begrip = lijst van gelijkwaardige woorden */
  function begrippen(woord) {
    if (!woord) return [];
    if (SYN[woord]) {
      return SYN[woord].split(' ').map(function (b) { return b.split('|'); });
    }
    var m = woord.match(/^(\d+)x(\d+)$/);
    if (m) return [[woord, m[1]]];
    for (var i = 0; i < KOPPEN.length; i++) {
      var k = KOPPEN[i];
      if (woord.length > k.length + 2 && woord.slice(-k.length) === k) {
        return begrippen(woord.slice(0, -k.length)).concat(begrippen(k));
      }
    }
    return [[woord]];
  }
  function ontleed(tekst, stopweg) {
    var uit = [];
    plat(tekst).split(' ').forEach(function (w) {
      if (!w || (stopweg && STOP.indexOf(' ' + w + ' ') > -1)) return;
      begrippen(w).forEach(function (b) { uit.push(b); });
    });
    return uit;
  }
  function afstand(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var v = [], i, j;
    for (j = 0; j <= b.length; j++) v[j] = j;
    for (i = 1; i <= a.length; i++) {
      var vorig = v[0]; v[0] = i;
      for (j = 1; j <= b.length; j++) {
        var tmp = v[j];
        v[j] = Math.min(v[j] + 1, v[j - 1] + 1, vorig + (a[i - 1] === b[j - 1] ? 0 : 1));
        vorig = tmp;
      }
    }
    return v[b.length];
  }
  var STAART = { s: 1, en: 1, n: 1, e: 1, es: 1, ten: 1, den: 1, ken: 1, len: 1, sen: 1, pen: 1, ssen: 1, tten: 1 };
  function lijkt(q, t, typt) {
    if (q === t) return 1;
    if (t.indexOf(q) === 0 && STAART[t.slice(q.length)]) return 1;
    if (q.indexOf(t) === 0 && STAART[q.slice(t.length)]) return 1;
    if (typt && q.length >= 3 && t.indexOf(q) === 0) return 0.75;
    if (q.length >= 5 && /^[a-z]+$/.test(q)) {
      var d = afstand(q, t);
      if (d === 1 || (d === 2 && q.length >= 9)) return 0.8;
    }
    return 0;
  }

  var INDEX = null;
  function bereid(lijst) {
    return lijst.map(function (c) {
      var woorden = [];
      var kern = ontleed(c.t, true);
      if (!kern.length) kern = ontleed(c.t, false);
      kern.forEach(function (b) { b.forEach(function (w) { if (woorden.indexOf(w) < 0) woorden.push(w); }); });
      ontleed(c.h.replace(/-/g, ' '), true).forEach(function (b) { b.forEach(function (w) { if (woorden.indexOf(w) < 0) woorden.push(w); }); });
      return { h: c.h, t: c.t, n: c.n, i: c.i, w: woorden, kern: kern.length, cijfer: /\d/.test(c.t) };
    });
  }
  /* zoek: geeft de best passende collecties, beste eerst */
  function zoek(tekst, opties) {
    if (!INDEX) return [];
    opties = opties || {};
    var typt = !!opties.typt;
    var q = ontleed(tekst, true);
    if (!q.length) q = ontleed(tekst, false);
    if (!q.length) return [];
    var heeftCijfer = /\d/.test(tekst);
    var res = [];
    INDEX.forEach(function (c) {
      var som = 0, raak = 0, gedekt = [];
      q.forEach(function (alts, qi) {
        var best = 0, bestW = null;
        var laatste = typt && qi === q.length - 1;
        alts.forEach(function (a) {
          c.w.forEach(function (w) {
            var s = lijkt(a, w, laatste);
            if (s > best) { best = s; bestW = w; }
          });
        });
        som += best;
        if (best > 0) raak++;
        if (best >= 0.75 && bestW && gedekt.indexOf(bestW) < 0) gedekt.push(bestW);
      });
      if (!raak) return;
      var score = som / q.length;
      if (score < 0.5) return;
      var dekking = Math.min(1, gedekt.length / Math.max(1, c.kern));
      var eind = score + 0.35 * dekking - (c.cijfer && !heeftCijfer ? 0.25 : 0);
      res.push({ c: c, s: eind, alles: raak === q.length && score >= 0.99, dekking: dekking });
    });
    res.sort(function (a, b) { return b.s - a.s || b.c.n - a.c.n; });
    var top = res.length ? res[0].s : 0;
    return res.filter(function (r) { return r.s >= top * 0.6; }).slice(0, opties.max || 6);
  }

  /* ---------- index laden ---------- */
  var laden = null;
  /* taalversie (Claude, 22/10/2026): op /fr/ de Franse index en links, en per taal een eigen bewaarde index */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var IDX_KEY = 'btol_zoekindex' + (ROOT === '/' ? '' : '_' + ROOT.replace(/\//g, ''));

  function laad() {
    if (INDEX) return Promise.resolve(INDEX);
    if (laden) return laden;
    try {
      var o = JSON.parse(sessionStorage.getItem(IDX_KEY) || 'null');
      if (o && o.l && o.t > Date.now() - 6 * 3600 * 1000) { INDEX = bereid(o.l); return Promise.resolve(INDEX); }
    } catch (e) {}
    laden = fetch(ROOT + 'collections?view=btol-zoekindex', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (l) {
        INDEX = bereid(l);
        try { sessionStorage.setItem(IDX_KEY, JSON.stringify({ t: Date.now(), l: l })); } catch (e) {}
        return INDEX;
      })
      .catch(function () { laden = null; return null; });
    return laden;
  }

  /* ---------- kaartjes in het zoekvenster ---------- */
  var PIJL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML.replace(/"/g, '&quot;'); }
  function kaart(c) {
    return '<a class="btol-ps__cat" href="' + ROOT + 'collections/' + esc(c.h) + '">' +
      '<span class="btol-ps__cat-beeld">' + (c.i ? '<img src="' + esc(c.i) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="btol-ps__cat-tekst"><strong>' + esc(c.t) + '</strong><small>' + esc(c.n === 1 ? btolT('aantal_product', '{aantal} product', { aantal: c.n }) : btolT('aantal_producten', '{aantal} producten', { aantal: c.n })) + '</small></span>' +
      '<span class="btol-ps__pijl" aria-hidden="true">' + PIJL + '</span></a>';
  }
  function delen() {
    var hs = document.querySelector('header-search');
    if (!hs) return null;
    var inp = hs.querySelector('input[name="q"]'), cont = hs.querySelector('.predictive-search__content');
    return inp && cont ? { hs: hs, inp: inp, cont: cont } : null;
  }
  function verrijk() {
    var d = delen();
    if (!d || !INDEX) return;
    var q = d.inp.value.trim();
    if (q.length < 2) return;
    var oud = d.cont.querySelector('.btol-ps__blok--cat[data-btol-slim]');
    if (oud && oud.getAttribute('data-btol-slim') === q) return;
    var res = zoek(q, { typt: true });
    if (!res.length) return;
    var ps = d.cont.querySelector('.btol-ps');
    if (!ps) {
      var niets = d.cont.querySelector('.predictive-search__no-results');
      if (!niets) return;
      ps = document.createElement('div');
      ps.className = 'predictive-search__results btol-ps';
      niets.parentNode.replaceChild(ps, niets);
    }
    var blok = ps.querySelector('.btol-ps__blok--cat');
    if (!blok) {
      blok = document.createElement('div');
      blok.className = 'btol-ps__blok btol-ps__blok--cat';
      blok.innerHTML = '<p class="btol-ps__kop">' + esc(btolT('categorieen', 'Categorieën')) + '</p><div class="btol-ps__cats"></div>';
      ps.insertBefore(blok, ps.firstChild);
    }
    ps.classList.remove('btol-ps--zonder-cat');
    blok.querySelector('.btol-ps__cats').innerHTML = res.map(function (r) { return kaart(r.c); }).join('');
    blok.setAttribute('data-btol-slim', q);
  }

  /* één duidelijke categorie? (voor Enter) */
  function duidelijk(q) {
    var r = zoek(q, { max: 2 });
    if (!r.length || !r[0].alles || r[0].dekking < 1) return null;
    if (r[1] && r[0].s - r[1].s < 0.1) return null;
    return r[0].c;
  }

  function start() {
    var d = delen();
    if (!d) return;
    d.inp.addEventListener('focus', laad);
    d.inp.addEventListener('input', function () { laad().then(verrijk); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a[aria-controls^="header-search"], [data-btol-zoek-open]')) laad();
    });
    if (window.MutationObserver) new MutationObserver(function () { if (INDEX) verrijk(); }).observe(d.cont, { childList: true });
    var form = document.getElementById('predictive-search-form');
    if (form) form.addEventListener('submit', function (e) {
      var knop = e.submitter;
      if (knop && knop.classList && knop.classList.contains('btol-ps__alles')) return;
      if (!INDEX) return;
      var c = duidelijk(d.inp.value);
      if (c) { e.preventDefault(); e.stopPropagation(); location.href = ROOT + 'collections/' + c.h; }
    }, true);
  }

  window.btolZoekSlim = { laad: laad, zoek: zoek, kaart: kaart };
  try { document.dispatchEvent(new CustomEvent('btol:zoekslim')); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();